export default "__VITE_ASSET__DA1LOY8M__"